import React, { useContext } from 'react'
import './Login.css'
import { Formik } from 'formik'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../firebase'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
const Login = () => {
    const navigate = useNavigate()
    const { dispatch } = useContext(AuthContext)
    return (
        <div className="login-container">
            <Formik
                initialValues={{ email: '', password: '' }}
                validate={values => {
                    const errors = {};
                    if (!values.email) {
                        errors.email = 'Please enter email id';
                    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                        errors.email = 'Invalid email address';
                    }
                    if (!values.password) {
                        errors.password = 'Please enter password'
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    const { email, password } = values
                    signInWithEmailAndPassword(auth, email, password)
                        .then((userCredential) => {
                            const user = userCredential.user.providerData[0];
                            dispatch({ type: "LOGIN", payload: user })
                            navigate("/organizer/dashboard");
                        })
                        .catch((error) => {
                            alert("Invalid Credentials");
                        })
                    setSubmitting(false);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit} className='login-form-container'>
                        <h1>Organizer Login</h1>
                        <div className="input-wrapper">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                name="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                autoComplete='off'
                                placeholder='Email id'
                            />
                            {errors.email && touched.email && (
                                <span className='login-error'>{errors.email}</span>
                            )}
                        </div>
                        <div className="input-wrapper">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                placeholder='Password'
                            />
                            {errors.password && touched.password && (
                                <span className='login-error'>{errors.password}</span>
                            )}
                        </div>
                        <button type="submit" disabled={isSubmitting}>
                            Login
                        </button>
                    </form>
                )}
            </Formik>
        </div>
    )
}

export default Login